import i18n from "Infrastructure/Translation/i18n";
import type { BaseTranslations } from "Infrastructure/Translation/Types/base";
import type { Language } from "Infrastructure/Translation/types";
import type { TOptions } from "i18next";
import { useTranslation } from "react-i18next";
import { createProxy, getPath, type ObjPathProxy } from "ts-object-path";

export const Resources = {
	base: createProxy<BaseTranslations>(),
};

export function getResourcePath<T>(proxy: ObjPathProxy<T, string>): string {
	const path = getPath(proxy);

	if (!path || path.length === 0) return "";
	if (path.length === 1) return path[0].toString();
	return `${path[0].toString()}.${path.slice(1).join(".")}`;
}

export function useResource<T>(namespace?: string) {
	const { t: i18Translation } = useTranslation(namespace);

	return {
		t: (resourcePath: ObjPathProxy<T, string>, options?: TOptions) => {
			return i18Translation(
				getResourcePath(resourcePath),
				options,
			) as unknown as string;
		},
	};
}

export const setLanguage = (language?: Language) => {
	i18n.changeLanguage(language);
};
